import React, { useState, useEffect } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import axios from '../utils/axiosConfig';
import { useAuth } from '../context/AuthContext';
import './AccountSetup.css';  // Can reuse the same styles

const InvitedUserSetup = () => {
    const navigate = useNavigate();
    const { login } = useAuth();
    const [formData, setFormData] = useState({
        firstName: '',
        lastName: '',
        password: '',
        confirmPassword: '',
        email: '',
        token: '',
        teamId: null,
        groupId: null
    });

    const [error, setError] = useState('');
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        const verifyInvitation = async () => {
            try {
                const token = new URLSearchParams(window.location.search).get('token');
                if (!token) {
                    setError('Invalid invitation link');
                    return;
                }

                const response = await axios.get(
                    `${process.env.REACT_APP_BACKEND_URL}/api/auth/verify-invitation/${token}`
                );

                if (response.data.success) {
                    setFormData(prev => ({
                        ...prev,
                        email: response.data.invitation.email,
                        token: token,
                        teamId: response.data.invitation.team_id,
                        groupId: response.data.invitation.group_id
                    }));
                }
            } catch (error) {
                console.error('Verification error:', error);
                setError('Invalid or expired invitation');
            } finally {
                setLoading(false);
            }
        };

        verifyInvitation();
    }, []);

    const handleSubmit = async (e) => {
        e.preventDefault();
        setError('');

        if (formData.password !== formData.confirmPassword) {
            setError('Passwords do not match');
            return;
        }

        try {
            const response = await axios.post(
                `${process.env.REACT_APP_BACKEND_URL}/api/auth/setup-account`,
                formData
            );

            if (response.data.success) {
                localStorage.setItem('token', response.data.token);
                login(response.data.user);
                navigate('/dashboard');
            }
        } catch (error) {
            console.error('Setup error:', error);
            setError(error.response?.data?.message || 'Error setting up account');
        }
    };

    if (loading) {
        return <div>Loading...</div>;
    }

    if (error) {
        return <div className="error">{error}</div>;
    }

    return (
        <div className="account-setup-container">
            <h2>Complete Your Account Setup</h2>
            <form onSubmit={handleSubmit}>
                <div className="form-group">
                    <input
                        type="text"
                        value={formData.firstName}
                        onChange={(e) => setFormData({...formData, firstName: e.target.value})}
                        placeholder="First Name"
                        required
                    />
                </div>
                <div className="form-group">
                    <input
                        type="text"
                        value={formData.lastName}
                        onChange={(e) => setFormData({...formData, lastName: e.target.value})}
                        placeholder="Last Name"
                        required
                    />
                </div>
                <div className="form-group">
                    <input
                        type="email"
                        value={formData.email}
                        disabled
                        placeholder="Email"
                    />
                </div>
                <div className="form-group">
                    <input
                        type="password"
                        value={formData.password}
                        onChange={(e) => setFormData({...formData, password: e.target.value})}
                        placeholder="Create Password"
                        required
                    />
                </div>
                <div className="form-group">
                    <input
                        type="password"
                        value={formData.confirmPassword}
                        onChange={(e) => setFormData({...formData, confirmPassword: e.target.value})}
                        placeholder="Confirm Password"
                        required
                    />
                </div>
                <button type="submit" className="submit-button">Complete Setup</button>
            </form>
        </div>
    );
};

export default InvitedUserSetup; 